"use client";

import React from "react";
import { SearchFilters } from "@/types/dto/search-filters/search-filters";
import { Box } from "@mui/material";
import FilterBox from "./filter-box";
import styles from "./styles.module.css";
import CountFilterOptions from "./count-filter-options";


interface CountFilterProps {
  filterData: SearchFilters,
  onChange?: (data: Record<string, string>) => void; // Updated to accept data parameter
  value?: string[]; // Changed to array for multi-select support
  isLoading?: boolean;
}



const CountFilter: React.FC<CountFilterProps> = ({ filterData, onChange, value, isLoading = false }) =>
(
  <FilterBox name={filterData.displayName}>
    <Box className={styles.flexColumnGap}>
      <CountFilterOptions
        options={filterData.options}
        fieldName={filterData.fieldName}
        onChange={onChange}
        value={value}
        isLoading={isLoading}
        title={filterData.displayName} // Pass title prop
      />
    </Box>
  </FilterBox>
);

export default CountFilter;